<template>
  <Section>
    <div class="d-flex flex-column">
      <div style="font-size: 16px; line-height: 1.25;">
        Below is a list of your redeemed rewards. Simply tap on a card to view or mark it as used.
      </div>

      <div class="d-flex flex-wrap mt-4 justify-space-between" style="row-gap: 10px;">
        <WalletItem
          v-for="redemption in wallet"
          :key="redemption.redemption_id"
          :brand="brand(redemption)"
          :redemption="redemption"
          @click="$router.push({ name: 'reward', params: { redemption_id: redemption.redemption_id } })"
        />
      </div>
    </div>
  </Section>
</template>

<script>

import { Section } from '@/components/pages'
import WalletItem from './WalletItem'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RewardsWalletTab',

  components: { Section, WalletItem },

  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapGetters('rewards', ['catalog', 'wallet']),
  },

  methods: {
    ...mapActions('rewards', ['loadCatalog', 'loadWallet']),

    brand(redemption) {
      const items = this.catalog.items
      return items.find( brand => brand.brand_key === redemption.brand_key )
    },
  },

  async created() {
    this.loading = true

    const p = this.loadCatalog()
    
    await this.loadWallet()
    await p

    this.loading = false
  },
}
</script>